import React from "react";
import clsx from "clsx";

const statusStyles = {
  primary: {
    bg: "bg-primary-100",
    text: "text-primary",
  },
  success: {
    bg: "bg-green-100",
    text: "text-green-600",
  },
  warning: {
    bg: "bg-yellow-100",
    text: "text-yellow-600",
  },
  error: {
    bg: "bg-red-100",
    text: "text-red-600",
  },
  default: {
    bg: "bg-gray-100",
    text: "text-gray-600",
  },
};

const Status = ({ label, type = "default", className = "px-2 py-1" }) => {
  const { bg, text } = statusStyles[type] || statusStyles.default;

  return (
    <div
      className={clsx(
        "inline-flex items-center rounded-full shadow-md",
        className,
        bg
      )}
    >
      <span
        className={clsx("text-xs font-medium uppercase tracking-wide", text)}
      >
        {label}
      </span>
    </div>
  );
};

export default Status;
